import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface HeaderState {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

interface HeaderContextValue {
  header: HeaderState;
  setHeader: (h: HeaderState) => void;
}

const HeaderContext = createContext<HeaderContextValue>({
  header: { title: "" },
  setHeader: () => {},
});

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [header, setHeaderState] = useState<HeaderState>({ title: "" });
  const setHeader = useCallback((h: HeaderState) => setHeaderState(h), []);
  return (
    <HeaderContext.Provider value={{ header, setHeader }}>
      {children}
    </HeaderContext.Provider>
  );
}

export function useHeaderContext() {
  return useContext(HeaderContext);
}
